<!-- 駅選択Select欄 -->
<template>
  <div class="select-wrap">
    <select class="form-control" :name="name" @change="updateValue">
      <!-- 乗車駅を選択してください -->
      <option value="1">
        {{ $t("TicketStoreTicketing.defaultStation") }}
      </option>

      <!-- stationsをループ表示 -->
      <div v-for="(option, index) in options" :key="index">
        <option :key="index" :value="option.code">
          {{ option.name }}
        </option>
      </div>
    </select>
  </div>
</template>

<script>
export default {
  name: "AtomSelect",
  props: {
    value: { type: String, required: true },
    options: { type: Array, required: true },
    name: { type: String, required: true },
  },
  mounted() {
    this.$emit("input", this.options[0].value);
  },
  methods: {
    updateValue: function (e) {
      this.$emit("input", e.target.value);
    },
  },
};
</script>
